/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_DescriptionInputs */

const en_cargos_sales_range_description = /** @type {(inputs: Cargos_Sales_Range_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net bags sold (deductions minus returns) per cargo over a date range.`)
};

const es_cargos_sales_range_description = /** @type {(inputs: Cargos_Sales_Range_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacos netos vendidos (deducciones menos devoluciones) por carga en un rango de fechas.`)
};

/**
* | output |
* | --- |
* | "Net bags sold (deductions minus returns) per cargo over a date range." |
*
* @param {Cargos_Sales_Range_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_description = /** @type {((inputs?: Cargos_Sales_Range_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_description(inputs)
	return es_cargos_sales_range_description(inputs)
});